import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { makeResetCache, fetchApi, notifyResponse, notifyError } from 'gossamer-front-end';
import { User, UserView } from 'cb-model';

export interface DeactivateUserButtonProps {
  userId: string;
}

export const DeactivateUserButton = (props: DeactivateUserButtonProps): React.JSX.Element => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const resetCache = makeResetCache(dispatch);
  const isProcessing = React.useRef(false);

  const handleDelete = async () => {
    const check = confirm('Are you sure? This action cannot be reversed.');
    if (!check) {
      return;
    }
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const resp = await fetchApi('POST', `/main/deactivate-user`, {
        userId: props.userId,
      });
      resetCache(User.id);
      resetCache(UserView.id);
      notifyResponse(resp);
      navigate('/admin/user/search');
    } catch (e) {
      notifyError(e, 'An error occurred while deactivating this user');
    }
    isProcessing.current = false;
  };

  return (
    <Button type="button" size="sm" variant="danger" onClick={handleDelete}>
      Deactivate
    </Button>
  );
};
